// extracted by mini-css-extract-plugin
module.exports = {"container":"UserProfile_container__3-Y8C","user_profile__section":"UserProfile_user_profile__section__iJ3tK"};